// dilip 01/12/2023 2699714747 Added Map Exception Records Step.
// Sai MAheshwar 01/13/2023 2699714747 fixed validation issue.
// Sohel 01/17/2023 2699714747 fixed field Name validation issue
// Sohel 01/19/2023 2698964415 hide position field and conditional validation
// Sohel 02/06/2023 2698964415 fixed id issue
// Sohel 04/14/2023 2701335619 Added Map Field Fields FOr Exception Type
// Prakash 16/05/2023 2701335619 Fixed specing issue in tab view

import React, {createRef, useEffect, useRef} from 'react';
import {Button} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {useSelector} from 'react-redux';
import {filteredCheckedData, tempSelectFunc} from '../../../../../util/Functions';

function SearchDMRecordTable({
  setTempSelectedRows,
  tempSelectedRows,
  setFieldValue,
  dmValues,
  dmArrayHelpers,
  handleClose,
  deletedIds,
  setDeletedIds,
}) {
  const tableRef = createRef();
  const tempUnCheckedRef = useRef();
  const {masterRecordFormatFieldsData} = useSelector(
    ({dataManagerRecord}) => dataManagerRecord,
  );
  console.log(
    masterRecordFormatFieldsData,
    'masterRecordFormatFieldsDatamasterRecordFormatFieldsDatamasterRecordFormatFieldsData',
  );
  const columns = [
    {
      title: 'Field Type',
      field: 'fieldType',
    },
    {
      title: 'Field Header',
      field: 'fieldHeader',
    },
    // {
    //   title: "Field Position",
    //   field: "fieldPosition",
    // },
    {
      title: 'Repository Name',
      field: 'repositoryName',
    },
    {
      title: 'Field Name',
      field: 'fieldName',
    },
    // {
    //   title: "Value",
    //   field: "fieldHeader",
    // },
    {
      title: 'Data Type',
      field: 'dataType',
    },
    // {
    //   title: "Start Position",
    //   field: "fieldHeader",

    //   hidden: fixedLength === "N",
    // },
    // {
    //   title: "Field Length",
    //   field: "fieldHeader",

    //   hidden: fixedLength === "N",
    // },
    {
      title: 'Format',
      field: 'format',
    },
  ];
  useEffect(() => {
    if (setTempSelectedRows) {
      setTempSelectedRows([]);
      tempUnCheckedRef.current = [];
    }
  }, []);
  return (
    <>
      <div className="col-12">
        <div className="d-flex justify-content-end new-standard-textfields mb-3">
          <Button
            variant="outlined"
            className={`reset-btn mr-2`}
            onClick={() => {
              handleClose();
            }}
          >
            Close
          </Button>
          <Button
            variant="outlined"
            className={`search-btn mr-3`}
            onClick={() => {
              const obj = tempSelectFunc('repositoryName', 'fieldName', tempUnCheckedRef);
              if (dmValues) {
                const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                  dmValues.selectedFields,
                  obj,
                  'repositoryName',
                  'fieldName',
                );
                const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                setFieldValue('selectedFields', allSelectedRows);
                if (newUnSelectedRows.length > 0) {
                  const allDeleteIds = [];
                  newUnSelectedRows.forEach((el) => {
                    if (el.dataManagerRecordFieldId) {
                      allDeleteIds.push(el.dataManagerRecordFieldId);
                    }
                  });

                  const ids = [...deletedIds, ...allDeleteIds];
                  setDeletedIds(ids);
                }
              }
              setTempSelectedRows([]);
              handleClose();
            }}
          >
            Save
          </Button>
        </div>
        <div className="custom-table  custom-toolbar-icons custom-actions-icon  global-field-table">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                if (tempSelectedRows) {
                  const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                  arr.push({
                    ...row,
                    dataManagerRecordFieldId: 0,
                    fieldName: row.fieldName,
                    fieldType: 'Record Field',
                    startPosition: '',
                    fieldLength: '',
                    fieldNames: '',
                    fieldPosition: '',
                    tableData: {
                      ...row.tableData,
                      id: row.processorFieldId,
                    },
                  });
                  setTempSelectedRows(arr);
                }
              } else {
                tempUnCheckedRef.current.push(row);
                const updatedRows = [...tempSelectedRows]
                  .filter(
                    (ele) =>
                      ele?.fieldName + ele?.repositoryName !==
                      row?.fieldName + row?.repositoryName,
                  )
                  .map((ele) => {
                    return {
                      ...ele,
                      tableData: {
                        ...ele.tableData,
                        id: ele.fieldName + ele?.repositoryName,
                      },
                    };
                  });
                setTempSelectedRows(updatedRows);
              }
            }}
            data={(query) => {
              return new Promise((resolve) => {
                const data = (masterRecordFormatFieldsData || []).map((o) => ({
                  ...o,
                  fieldName: o?.repositoryFieldCode || '',
                  mapFieldType: 'Record Field',
                }));
                const newObj = {};
                if (dmValues) {
                  [...dmValues.selectedFields, ...tempSelectedRows].forEach((el) => {
                    if (!newObj[el.fieldName + el.repositoryName]) {
                      newObj[el.fieldName + el.repositoryName] = el;
                    }
                  });
                }
                const newRows = data?.map((elem) => {
                  if (newObj[elem.fieldName + elem.repositoryName]) {
                    return {...elem, tableData: {...elem.tableData, checked: true}};
                  } else {
                    return {
                      ...elem,
                      tableData: {...elem.tableData, checked: false},
                    };
                  }
                });
                resolve({
                  data: newRows || [],
                  page: query?.page,
                  totalCount: newRows?.length || 0,
                });
              });
            }}
            options={{
              search: false,
              toolbar: true,
              toolbarButtonAlignment: 'left',
              selection: true,
              selectionProps: (rowData) => {
                let disabledFields = false;
                if (dmValues?.selectedFields) {
                  dmValues?.selectedFields?.forEach((el) => {
                    if (
                      el.repositoryName?.concat(el.fieldName) ===
                        rowData.repositoryName?.concat(rowData.fieldName) &&
                      el.mapFieldType === 'DB Field'
                    ) {
                      disabledFields = true;
                    }
                  });
                }

                const checked = rowData?.active === 'no' ? {checked: false} : {};
                return {
                  disabled: disabledFields,
                  ...checked,
                };
              },
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              showTextRowsSelected: false,
              paging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
          />
        </div>
      </div>
    </>
  );
}

export default SearchDMRecordTable;
